import { Crown, Shield, User } from 'lucide-react'

export function getRoleBadge(role: string) {
  switch (role) {
    case 'owner':
      return {
        icon: Crown,
        label: 'Owner',
        className: 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400',
      }
    case 'admin':
      return {
        icon: Shield,
        label: 'Admin',
        className: 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400',
      }
    default:
      return {
        icon: User,
        label: 'Member',
        className: 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400',
      }
  }
}

export function getInitials(name: string): string {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)
}

export function formatDate(dateString?: string): string {
  if (!dateString) return '-'
  return new Date(dateString).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })
}
